// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"375":"8f5d09c3","506":"2452c40d","678":"fb4876fc"}[chunkId] + ".chunk.css";
};